import { IXandrAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { isVideoAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads/adrequest";
import { createLogger } from "@almamedia/amr-adtech-stack/lib/utils";

const logger = createLogger("outstream");

function outstream(adObject: IXandrAdObject): void {
  logger.logInfo("adObj", JSON.stringify(adObject, null, 2));

  // If not video do nothing
  if (!isVideoAdObject(adObject)) return;

  const target = adObject.targetId;
  const outstreamE = window.document.getElementById(target);

  if (outstreamE) {
    const outstreamIframeE = outstreamE.getElementsByTagName("iframe")?.[0];

    if (!outstreamIframeE?.contentDocument) {
      logger.logWarn(`Could not find outstream contentDocument`);
      return;
    }

    // Center players iframe
    outstreamIframeE.style.display = "block";
    outstreamIframeE.style.margin = "0 auto";

    // Aligh header text to left
    const adIndicatorTextE = outstreamIframeE.contentDocument.getElementById(
      "ad_indicator_text"
    );

    if (adIndicatorTextE) {
      adIndicatorTextE.style.left = "0px";
      adIndicatorTextE.style.textAlign = "left";
    }
    // change width to auto
    const adText = outstreamIframeE.contentDocument.getElementById(
      "top_chrome"
    );
    if (adText) adText.style.width = "auto";

    outstreamE.classList.remove("ad-text-headline-article");
    // IE might not have this? Adds a margin to outstream inside an article to preserve the flow of content
    if (outstreamE.nextElementSibling) {
      const followingEl = outstreamE.nextElementSibling;
      if (followingEl && followingEl.tagName !== "DIV") {
        // TODO: Check
        outstreamE.setAttribute("style", "margin-bottom: 14px");
      }
    }
  }
}

// eslint-disable-next-line import/prefer-default-export
export { outstream };
